import React, { useState } from "react";
import { StepData, StepItem } from "./StepItem";
import "./AccordionStepper.scss";
import { ToggleLabel } from "./types";
import ToggleContent from "./ToggleContent/ToggleContent";
import { SectionHeading } from "../../Section";

interface AccordionStepperProps {
  mainTitle?: string;
  toggleStepsLabels: ToggleLabel;
  toggleSingleStepsLabel: ToggleLabel;
  steps: StepData[];
}

export const AccordionStepper: React.FC<AccordionStepperProps> = ({
  steps,
  mainTitle,
  toggleStepsLabels,
  toggleSingleStepsLabel,
}) => {
  const [expandedSteps, setExpandedSteps] = useState<boolean[]>(
    steps.map((_, index) => index === 0),
  );
  const [allOpen, setAllOpen] = useState(false);

  const toggleAll = () => {
    const newState = !allOpen;
    setExpandedSteps(steps.map(() => newState));
    setAllOpen(newState);
  };

  const toggleStep = (index: number) => {
    const updated = [...expandedSteps];
    updated[index] = !updated[index];
    setExpandedSteps(updated);
  };

  return (
    <div className="accordion-stepper">
      <SectionHeading
        color={"primary"}
        title={mainTitle}
        className="mainTitle"
        fs="4"
        mdFs="2"
      />
      <ToggleContent
        className="toggle-all"
        onClick={toggleAll}
        isOpen={allOpen}
        toggleLabels={toggleStepsLabels}
      />

      {steps.map((step, index) => (
        <StepItem
          key={index}
          index={index}
          title={step.title}
          content={step.content}
          isOpen={expandedSteps[index]}
          detailLabels={toggleSingleStepsLabel}
          onToggle={() => toggleStep(index)}
        />
      ))}
    </div>
  );
};
